import { COLOR_PALETTE } from 'constants/ui';

import { ErrorFilledIcon, InfoFilledIcon, SuccessFilledIcon, WarningFilledIcon } from '../../icons';

export const ConfirmPopperType = {
  SUCCESS: 'success',
  ERROR: 'error',
  INFO: 'info',
  WARNING: 'warning',
};

export const confirmPopperIconMap = {
  [ConfirmPopperType.SUCCESS]: SuccessFilledIcon,
  [ConfirmPopperType.ERROR]: ErrorFilledIcon,
  [ConfirmPopperType.INFO]: InfoFilledIcon,
  [ConfirmPopperType.WARNING]: WarningFilledIcon,
};

export const confirmPopperIconColorMap = {
  [ConfirmPopperType.SUCCESS]: COLOR_PALETTE.GREEN[7],
  [ConfirmPopperType.ERROR]: COLOR_PALETTE.RED[7],
  [ConfirmPopperType.INFO]: COLOR_PALETTE.BRAND[7],
  [ConfirmPopperType.WARNING]: COLOR_PALETTE.ORANGE[7],
};
